export const VIEWER_SHAPE_AVERAGE_KEY = "avg";

export type ViewerShapeChartPoint = {
  minute: number;
  avgViewers: number;
};

export type ViewerShapeChartSeries = {
  id: string;
  points: ViewerShapeChartPoint[];
};

export type ViewerShapeChartRow = {
  minute: number;
} & Record<string, number | null>;

/** One row per minute that any curve has, plus a break where a curve skips minutes. */
export function buildViewerShapeChartRows(
  average: ViewerShapeChartPoint[],
  series: ViewerShapeChartSeries[],
): ViewerShapeChartRow[] {
  const minutes = new Set<number>();
  const avgBy = new Map<number, number>();
  for (const point of average) {
    if (!Number.isFinite(point.minute)) continue;
    minutes.add(point.minute);
    avgBy.set(point.minute, point.avgViewers);
  }

  const prepared = series.map((item) => {
    const by = new Map<number, number>();
    const sorted: number[] = [];
    for (const point of item.points) {
      if (!Number.isFinite(point.minute)) continue;
      by.set(point.minute, point.avgViewers);
      sorted.push(point.minute);
      minutes.add(point.minute);
    }
    sorted.sort((left, right) => left - right);
    for (let index = 1; index < sorted.length; index += 1) {
      const previous = sorted[index - 1]!;
      const current = sorted[index]!;
      if (current - previous > 1) minutes.add(previous + 1);
    }
    return {
      id: item.id,
      by,
      first: sorted[0] ?? null,
      last: sorted[sorted.length - 1] ?? null,
    };
  });

  return Array.from(minutes)
    .sort((left, right) => left - right)
    .map((minute) => {
    const row: ViewerShapeChartRow = {
      minute,
      [VIEWER_SHAPE_AVERAGE_KEY]: avgBy.get(minute) ?? null,
    };
    for (const item of prepared) {
      if (
        item.first == null ||
        item.last == null ||
        minute < item.first ||
        minute > item.last
      ) {
        row[item.id] = null;
      } else {
        row[item.id] = item.by.get(minute) ?? null;
      }
    }
    return row;
  });
}
